export default __webpack_public_path__ + "static/media/more-horizontal.71fd84d4.svg";